// extracted by mini-css-extract-plugin
export const productCell = "products-module--productCell--3NBWF";